import React, { useState } from 'react'
import CommonModal from '../../UiKits/Modals/common/modal'
import { H5, P } from '../../../AbstractElements';
import { Descriptions } from 'antd';
import moment from 'moment';
import { useLocation } from 'react-router';
import { removeSearchParams } from '../../../utils';

const ActivityDetail = ({ activity: { details, show }, setActivity }) => {
  const location = useLocation();

  const renderDetailsItem = (label, content) => (
    <Descriptions.Item label={<span>{label}</span>}>
      <span>{content}</span>
    </Descriptions.Item>
  );

  const closeActivity = () => {
    removeSearchParams(location);
    setActivity({
      show: false,
      details: {}
    })
  }

  return (
    <CommonModal
      isOpen={show}
      toggler={() => closeActivity()}
      showCloseBtn={true}
      successText={'Close'}
      title='Activity Details'
      success={() => closeActivity()}
      bodyClass='full-screen-modal'
      size="lg"
    >
      <Descriptions bordered column={1}>
        {renderDetailsItem('Studen Email', details.studentEmail)}
        {renderDetailsItem('Activity', details.activity ?? 'N/A')}
        {renderDetailsItem('Type', details?.type)}
        <Descriptions.Item label={<span>Date</span>}>
          <span>{moment(details.createdAt?.seconds * 1000).format('LLL')}</span>
        </Descriptions.Item>

      </Descriptions>
    </CommonModal >
  )
}

export default ActivityDetail